export interface Area {
  w: number
  h: number
  x?: number
  y?: number
}

export interface BoxBoundary {
  w: number
  h: number
  x: number
  y: number
}

export interface PackedRect {
  id: string
  w: number
  h: number
  r: number
  cnt: number
  isTechnicalDrawing: boolean
  key: number
}

export interface Drawing {
  name: string
  w: number
  h: number
  r: number
}

export interface SolutionRect {
  id: string
  pairId: string
  w: number
  h: number
  r: number
  x: number
  y: number
  pricePerRect?: number
}

export interface ComputedData {
  allBox: BoxBoundary
  boundingBox: BoxBoundary
  spacing: number
  pricePerM2: number
  rects: Array<SolutionRect>
  solvedRects: Array<SolutionRect>
  totalAreaMM2: number
  usedAreaMM2: number
  wasted: number
  priceStats: { [key: string]: { one: number; all: number; cnt: number } }
}

export enum Orientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

export interface WorkerMsgIn {
  docWidth: number
  docHeight: number
  spacing: number
  docBorder: number
  rects: Array<PackedRect>
  pricePerM2: number
  selectedAlgos: Array<string>
  currency: Currency
  rate: number
  foil: Foil
  marginDivisor: number
  machineGripMM: number
  plotrPrice: [number, number, number],
  plotrBreaks: [number, number, number, number]
}

export interface Solution {
  computedData: ComputedData
  boundingBox?: BoxBoundary
  allBox: BoxBoundary
  bestAlgo: string
}

export interface SubmitPackage {
  foil: {
    width: number
    height: number
    spaces: number
    border: number
    priceCZK: number
  }
  cutouts: {
    packed: Array<PackedRect>
    solved: Array<SolutionRect>
  }
  svg: SVGSVGElement | undefined
}

export type Currency = "CZK" | "EUR"
export type Foil = "LOTUS Foil" | "custom foil"
export type UIWidth = "Large" | "Medium" | "SMedium" | "Small" | "ExtraSmall"
export function widthToPx(width: UIWidth): string {
  if (width === "Large") return "410px"
  if (width === "Medium") return "290px"
  if (width === "SMedium") return "165px"
  if (width === "Small") return "100px"
  return "70px"
}
